import script from "./TheProgramDrawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheProgramDrawer.vue?vue&type=script&lang=ts&setup=true"

import "./TheProgramDrawer.vue?vue&type=style&index=0&id=c39f6622&lang=sass&setup=true"

const __exports__ = script;

export default __exports__